import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const PaymentService = ({ values }) => (
  <Content>
    {({
      initialQuestionsPaymentServiceLabel,
      initialQuestionsPaymentServiceYes = '',
      initialQuestionsPaymentServiceNo = '',
      businessRegisteredText = ''
    }) => (
      <div>
        <Field name="paymentService" subscription={{ touched: true, error: true }}>
          {({ input }) => (
            <GenericFieldWrapper
              inputId="paymentService"
              title={initialQuestionsPaymentServiceLabel}
              description={businessRegisteredText}
            >
              <GenericRadio.InlineSet
                groupName="paymentService-group"
                items={[
                  {
                    id: initialQuestionsPaymentServiceYes,
                    labelText: initialQuestionsPaymentServiceYes
                  },
                  {
                    id: initialQuestionsPaymentServiceNo,
                    labelText: initialQuestionsPaymentServiceNo
                  }
                ]}
                {...input}
                selectedId={values.paymentService}
              />
            </GenericFieldWrapper>
          )}
        </Field>
      </div>
    )}
  </Content>
);

export default PaymentService;
